var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddMoreDependent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 43,
    viewBox: "0 0 44 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "white",
    stroke: "#00274C",
    strokeDasharray: "3 3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 19.375C30.1046 19.375 31 20.2704 31 21.375V21.6593C31 22.7638 30.1046 23.6593 29 23.6593H26.2863C25.1817 23.6593 24.2863 24.5547 24.2863 25.6593V28C24.2863 29.1046 23.3909 30 22.2863 30H21.75C20.6454 30 19.75 29.1046 19.75 28V25.625C19.75 24.5204 18.8546 23.625 17.75 23.625H15C13.8954 23.625 13 22.7296 13 21.625V21.375C13 20.2704 13.8954 19.375 15 19.375H17.75C18.8546 19.375 19.75 18.4796 19.75 17.375V15C19.75 13.8954 20.6454 13 21.75 13H22.25C23.3546 13 24.25 13.8954 24.25 15V17.375C24.25 18.4796 25.1454 19.375 26.25 19.375H29Z",
    fill: "#00274C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddMoreDependent);
export default __webpack_public_path__ + "static/media/addMoreDependent.0035525c8069c1d955b93794d008fc94.svg";
export { ForwardRef as ReactComponent };